import client from '@/clients/customer/api-client';

export const getStoreDataByKey = (key: string) =>
  client.get(`/data-stores/${key}`);

export const getStoreDataByKeyParam = (key: string) =>
  client.get(`/data-stores?key=${key}`);
